import { FC } from 'react';
import { Link } from 'react-router-dom';

import { ReactComponent as PendingApprovalIcon } from 'assets/image/dashboard/pending-approval.svg';
import { ReactComponent as CircleArrowButton } from 'assets/image/dashboard/circle-arrow-button.svg';

import { urls } from 'core/appUrls';
import { formatInteger } from 'core/functions/formatNumber';

import styles from './PendingVolunteersStatistic.module.scss';

type PendingVolunteersStatisticProps = {
	claimCount?: number;
};

const PendingVolunteersStatistic: FC<PendingVolunteersStatisticProps> = ({ claimCount = 0 }) => {
	const title = 'Volunteers Pending Approval';
	const volunteersSignUpRequestsUrl = `${urls.supperAdminVolList}?pending-approval`;

	return (
		<section className={styles.pendingVolunteersStatistic}>
			<div className={styles.pendingVolunteersStatistic_wrapper}>
				<PendingApprovalIcon className={styles.pendingVolunteersStatistic_icon} />
				<div className={styles.pendingVolunteersStatistic__content}>
					<span className={styles.pendingVolunteersStatistic__content_title}>{title}</span>
					<span className={styles.pendingVolunteersStatistic__content_counter}>
						{formatInteger(claimCount)}
					</span>
				</div>
				<Link to={volunteersSignUpRequestsUrl} className={styles.pendingVolunteersStatistic_link}>
					<CircleArrowButton title={title} />
				</Link>
			</div>
		</section>
	);
};

export default PendingVolunteersStatistic;
